<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="10" offset-md="1">
        <SearchBar :title="$t('ACCOUNT.LIST')" @filterInput="setFilter" />
        <b-table v-if="accountsLoaded"  show-empty :empty-text="$t('COMMON.NO_RECORD')" responsive="sm" :items="accounts" :fields="accountFields" :filter="filter">
          <template slot="name" slot-scope="data">
            <router-link id = "accountLink" :to="'/super_admin/accounts/' + data.item.id">
              {{ data.value }}
            </router-link>
          </template>
          <template slot="users_count" slot-scope="data">
            <a class="container" @mouseover="fetchUsers(data.item.id)" :key="data.item.id" :id = "'account' + data.item.id"> {{data.value}}
              <b-popover :target="'account' + data.item.id">
                <b-row class="closePopOver">
                  <i @click="closePopOver" class="fa fa-close popOverClose" aria-hidden="true"></i>
                </b-row>
                <b-row class="userlist">
                  <div v-if="!usersLoaded">
                    <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div id="popOverBody">
                    <div class="userlink" v-if="usersLoaded" v-for="user in popOverContent">
                      <router-link id="users" :to="'/admin/users/' + user.id">
                        {{ user.email }}
                      </router-link>
                    </div>
                  </div>
                  <div v-if = "popOverContent.length === 0 && usersLoaded">
                       No Users found
                  </div>
                </b-row>
              </b-popover>
            </a>
          </template>
          <template slot="account_type" slot-scope="data">{{ data.value }}</template>
          <template slot="expires_at" slot-scope="data">{{ data.value }}</template>
          <template slot="status" slot-scope="data" v-if="data.item.id > 1">
            <router-link :to="'/admin/new'"> <div class="fa fa-user-plus mr-2" v-b-tooltip.hover :title="$t('USERS.ADD_NEW')"></div></router-link>
            <b-button size="sm"
                      :variant="data.value === 'ACTIVE' ? 'success' : 'danger'"
                      @click="handleAccountStatus(data)"
                      v-b-tooltip.hover :title="data.value === 'ACTIVE' ? $t('COMMON.DEACTIVATE') : $t('COMMON.ACTIVATE')"
                      :disabled="data.value === 'DELETING' || data.item.inactive_type === 'date'">
              {{ data.value }}
            </b-button>
            <router-link :to="'/super_admin/accounts/' + data.item.id">
              <b-button class="ml-2" size="sm" variant="primary"
                        v-b-tooltip.hover :title="$t('COMMON.EDIT')"
                        :disabled="data.value === 'DELETING'">
                {{$t('COMMON.EDIT').toUpperCase()}}
              </b-button>
            </router-link>
            <b-button class="ml-2" size="sm" variant="danger"
                      @click="confirmDeleteAccount(data)"
                      v-b-tooltip.hover :title="$t('COMMON.DELETE_PERMANENTLY')"
                      :disabled="data.value === 'DELETING'">
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
        <b-card v-else>
          <content-placeholders>
            <content-placeholders-img :style="{height: '400px'}" />
          </content-placeholders>
        </b-card>
      </b-col>
    </b-row>
    <b-modal hide-header-close centered :title="$t('COMMON.DELETE_CONFIRM')" ref="deleteAccountModal" @hidden="cancelDelete" :ok-title="$t('COMMON.DELETE')" :cancel-title="$t('COMMON.CANCEL')" @ok="deleteAccount" ok-variant="secondary" cancel-variant="light">
      <div class="delete-warning">
        <p>{{$t('COMMON.MSG_DEL')}}</p>
        <p>{{ $t('COMMON.MSG_PERM_DEL')}}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import router from '../../router'
import SearchBar from '../../components/utils/SearchBar'
import svg from '../../_svg.js'

export default {
  data () {
    return {
      accounts: [],
      accountsLoaded: false,
      accountFields: [
        { label: 'Id', key: 'id' },
        { label: this.$t('COMMON.NAME'), key: 'name' },
        { label: `#${this.$t('COMMON.USERS')}`, key: 'users_count' },
        { label: this.$t('COMMON.ACCOUNT_TYPE'), key: 'account_type' },
        { label: this.$t('COMMON.EXPIRES_AT'), key: 'expires_at' },
        { label: this.$t('COMMON.STATUS'), key: 'status' }
      ],
      filter: null,
      selectedAccount: null,
      popOverContent: [],
      usersLoaded: false,
      currentAccountId: null,
      svg: svg
    }
  },
  components: {
    SearchBar
  },
  computed: {
    ...mapGetters(['idToken', 'isSuperAdmin'])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.isSuperAdmin) {
        Vue.axios.get('/admin/accounts', { headers: { Authorization: `Bearer ${vm.idToken}` } })
          .then(res => {
            vm.$store.state.accounts = res.data.accounts
            vm.accounts = vm.$store.state.accounts
            vm.accountsLoaded = true
            next()
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      } else {
        router.replace('/Not-Found-404')
      }
    })
  },
  methods: {
    closePopOver () {
      this.$root.$emit('bv::hide::popover')
    },
    fetchUsers (id) {
      if (id !== this.currentAccountId) {
        this.popOverContent = []
        this.usersLoaded = false
        this.currentAccountId = id
        this.$root.$emit('bv::hide::popover')
        this.$root.$emit('bv::show::popover', 'account' + id)
        Vue.axios.get('/admin/users/users_by_roles?role_id=' + '-1' + '&account_id=' + id, {
          headers: {
            Authorization: `Bearer ${this.idToken}`,
            'Cache-Control': 'no-cache, no-store',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        })
          .then(res => {
            this.popOverContent = res.data.users
            this.usersLoaded = true
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    },
    setFilter (filter) {
      this.filter = filter
    },
    handleAccountStatus (data) {
      let id = data.item.id
      let status = data.value === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
      let accountData = new window.FormData()
      accountData.append('status', status)
      Vue.axios.post('/admin/accounts/' + id + '/update_status', accountData, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.$store.state.accounts = this.updateAccounts(res.data)
          Vue.toasted.show(res.data.msg)
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    updateAccounts (data) {
      return this.accounts.slice().map(account => {
        if (account.id === data.id) {
          account.status = data.status
        }
        return account
      })
    },
    confirmDeleteAccount (data) {
      this.selectedAccount = data.item.id
      this.$refs.deleteAccountModal.show()
    },
    cancelDelete () {
      this.selectedAccount = null
    },
    deleteAccount () {
      if (this.selectedAccount) {
        Vue.axios.delete('/admin/accounts/' + this.selectedAccount, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            this.$store.state.accounts = this.updateAccounts(res.data)
            this.accounts = this.$store.state.accounts
            Vue.toasted.show(res.data.msg)
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.delete-warning {
  font-size : 1rem;
  color: red;
}

.closePopOver {
  margin-left: 0px;
  margin-right: 0px;
}

.userlink{
  margin-bottom:10px;
  margin-right: 10px
}

.userlist {
  margin-left: 0px;
  margin-right: 0px;
}

#popOverBody {
  overflow-y: scroll;
  max-height: 170px;
  margin-left: 0px;
  margin-right: 0px;
}

#accountLink {
  color: black ;
}

#accountLink:hover {
  text-decoration: underline;
}

#users {
  color: black ;
}

#users:hover {
  text-decoration: underline;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 3px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgb(183, 184, 185);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}

.popOverClose {
  cursor: pointer;
  color: grey ;
  margin-left:95%;
  margin-bottom:3px;
}
</style>


// WEBPACK FOOTER //
// src/views/superAdmin/accounts.vue